import React from 'react';

import Head from 'next/head';
import { Thing, WithContext } from 'schema-dts';

import { serializeJsonLd } from '@utils/seo';

type SchemaScriptProps = {
    id: string;
    schema: WithContext<Thing>;
};

export const SchemaScript = ({ id, schema }: SchemaScriptProps) => (
    <Head>
        <script
            key={id}
            id={id}
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: serializeJsonLd(schema) }}
        />
    </Head>
);
